export enum TaskStatus {
    NotStarted = 'Not Started',
    InProgress = 'In Progress',
    Completed = 'Completed',
    OnHold = 'On Hold',
    Cancelled = 'Cancelled'
}
